//import { mq, variables } from '../../cssInJs'

export default{
  backToResultBtnContainer : {
    maxWidth: '960px'
  }
}